interface IAuthButton {
    className?: string;
    title: string;
    disabled?: boolean;
    loading?: boolean;
    onClick?: Function
}

const AuthButton = ({ className, title, onClick = () => { }, disabled = false, loading = false }: IAuthButton) => {
    return (
        <>
            {
                loading ?
                    <div
                        className={`flex items-center justify-center rounded-md w-[118px] py-2 px-4 h-15 border border-transparent text-center text-xl font-normal bg-[#D4DCDA] text-white transition-all select-none mobile:h-10 mobile:text-sm mobile:w-[90px]
                        ${className} `}
                    >
                        로딩중...
                    </div> :
                    <button
                        className={`rounded-md w-[118px] py-2 px-4 h-15 border text-center text-xl font-normal transition-all cursor-pointer 
                        hover:bg-hover hover:text-white
                        disabled:cursor-not-allowed disabled:bg-[#9D9EB7] disabled:text-white select-none 
                        mobile:h-10 mobile:text-sm mobile:w-[90px]
                        ${className}`}
                        type="button"
                        disabled={disabled}
                        onClick={() => onClick()}
                    >
                        {title}
                    </button>

            }
        </>
    );
}

export default AuthButton;
